import styled from "styled-components";

export const Pagina = styled.div`
  min-height: 740px;
  margin-top: -30px;
`;

export const HeaderArrow = styled.span`
  display: flex;
  align-items: center;
  /* font-size: 28px; */
  font-weight: bold;
  align-items: center;
  margin-top: 5px;
  color: #295661;
  margin-right: 5px;
`;

export const BotaoVoltar = styled.div`
  border: none;
  display: flex;
  color: #295661;
  cursor: pointer;
  margin-right: 5px;
`;

export const Titulo = styled.span`
  font-family: "SF Pro Display";
  font-weight: ${(props) => (props.negrito ? "bold" : 300)};
  font-size: 24px;
  line-height: 29px;
  padding: 32px 5px 16px 0px;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.secundaria};
`;

export const HeaderAcessoInterno = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  height: 24px;
  color: #295661;
  margin-bottom: 20px;
`;

export const Descricao = styled.span`
  font-family: "SF Pro Display";
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 32px;
  display: flex;
  color: ${(props) => props.theme.colors.secundaria};
`;

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  position: relative;
  width: 315px;
  height: 450px;
  background: ${(props) => props.theme.colors.Branco};
  box-shadow: 10px 10px 21px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  margin: 20px;
`;

export const BotaoCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  padding: 8px 16px;
  width: 17rem;
  bottom: 0%;
  height: 2rem;
  background: ${(props) => props.theme.colors.Verde};
  box-shadow: 14px 15px 21px rgba(0, 0, 0, 0.05);
  border-radius: 230px;
  margin-bottom: 20px;
  &:hover {
    cursor: pointer;
  }
`;

export const AbasContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
`;

export const BotaoAba = styled.div`
  font-weight: ${(props) => (props.active ? 600 : 400)};
  font-size: 16px;
  line-height: 19px;
  margin-right: 15px;
  /* identical to box height */

  display: flex;
  align-items: center;
  border-bottom: ${(props) => (props.active ? "2px solid #00C254" : "none")};

  &:hover {
    cursor: pointer;
  }
`;

// Estilos do Modal
export const ModalContainer = styled.div`
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const CloseModal = styled.span`
  display: flex;
  justify-content: end;
  font-size: 25px;
  &:hover {
    cursor: pointer;
    background-color: rgb(255, 0, 0, 0.3);
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const TituloModal = styled.span`
  font-family: "SF Pro Display";
  font-weight: ${(props) => (props.negrito ? "bold" : 600)};
  font-size: 24px;
  display: flex;
  color: ${(props) => props.theme.colors.secundaria};
`;

export const SubtituloModal = styled.span`
  font-family: "SF Pro Display";
  font-weight: ${(props) => (props.negrito ? "bold" : 300)};
  font-size: 24px;
  line-height: 29px;
  padding: 32px 5px 16px 0px;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.secundaria};
`;

export const ModalBody = styled.div`
  position: relative;
  margin: auto;
`;

export const ConteudoModal = styled.span`
  font-family: "SF Pro Display";
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin: auto;
  color: ${(props) => props.theme.colors.secundaria};
  position: relative;
  padding-bottom: 25px;
`;

export const LinkManual = styled.span`
  margin-bottom: 20px;
  position: relative;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const StyledModal = {
  overlay: {
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)",
  },

  content: {
    boxShadow: "20px 20px 60px #bebebe, -20px -20px 60px #ffffff",
    display: "flex",
    position: "relative",
    inset: "auto",
    border: "none",
    background: "#fff",
    width: "700px",
    height: "auto",
    maxHeight: "500px",
    marginTop: "20px",
    marginBottom: "20px",
    WebkitOverflowScrolling: "touch",
    borderRadius: "20px",
    outline: "none",
    padding: "40px",
    zIndex: "1",
  },
};